(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  class ProductHero extends HTMLElement {
    constructor() {
      super();
      this.initGallery();
      this.initQuantitySelector();
      this.initVariantSelector();
    }

    initGallery() {
      if (typeof Swiper === 'undefined') {
        // Load Swiper dynamically if needed
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
        script.onload = () => this.setupSwiper();
        document.head.appendChild(script);

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
        document.head.appendChild(link);
      } else {
        this.setupSwiper();
      }
    }

    setupSwiper() {
      const sectionId = this.closest('[data-section-id]').dataset.sectionId;

      const galleryThumbs = new Swiper(`#gallery-thumbs-${sectionId}`, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });

      const galleryMain = new Swiper(`#gallery-main-${sectionId}`, {
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        thumbs: {
          swiper: galleryThumbs,
        },
      });
    }

    initQuantitySelector() {
      const quantityInput = this.querySelector('.quantity-selector__input');
      const decreaseBtn = this.querySelector('[data-action="decrease"]');
      const increaseBtn = this.querySelector('[data-action="increase"]');

      decreaseBtn?.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });

      increaseBtn?.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value);
        const maxValue = parseInt(quantityInput.max);
        if (currentValue < maxValue) {
          quantityInput.value = currentValue + 1;
        }
      });
    }

    initVariantSelector() {
      const form = this.querySelector('.product-form');
      const optionInputs = this.querySelectorAll('.option-button__input, .color-swatch__input');

      optionInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updateVariant();
        });
      });
    }

    updateVariant() {
      // Variant update logic would go here
      // This would communicate with Shopify's variant API
    }
  }

  customElements.define('product-hero', ProductHero);

  document.querySelector('.product-hero')?.classList.add('product-hero');
  const productHeroElement = document.createElement('product-hero');
  const productHeroSection = document.querySelector('.product-hero');
  if (productHeroSection && !productHeroSection.hasAttribute('is')) {
    productHeroSection.replaceWith(productHeroElement);
    productHeroElement.innerHTML = productHeroSection.innerHTML;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-plaud-exact"] && !Shopify.designMode) return;
  try {
    
  // Gallery functionality
  document.addEventListener('DOMContentLoaded', function() {
    const sectionId = document.querySelector('[data-section-id]').dataset.sectionId;
    const galleryEl = document.getElementById(`plaud-gallery-${sectionId}`);

    if (typeof Swiper !== 'undefined' && galleryEl) {
      const swiper = new Swiper(`#plaud-gallery-${sectionId}`, {
        loop: false,
        on: {
          slideChange: function() {
            const current = this.activeIndex + 1;
            document.querySelector('.plaud-gallery__current').textContent = current;

            // Update thumbnail active state
            document.querySelectorAll('.plaud-gallery__thumb').forEach((thumb, index) => {
              thumb.classList.toggle('active', index === this.activeIndex);
            });
          }
        }
      });

      // Navigation
      document.querySelector('.plaud-gallery__nav-prev').addEventListener('click', () => swiper.slidePrev());
      document.querySelector('.plaud-gallery__nav-next').addEventListener('click', () => swiper.slideNext());

      // Thumbnail click
      document.querySelectorAll('.plaud-gallery__thumb').forEach((thumb, index) => {
        thumb.addEventListener('click', () => swiper.slideTo(index));
      });
    }

    // Quantity controls
    document.querySelectorAll('[data-action="decrease"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const input = e.target.parentElement.querySelector('input, span');
        const current = parseInt(input.textContent || input.value);
        if (current > 1) {
          if (input.tagName === 'SPAN') {
            input.textContent = current - 1;
          } else {
            input.value = current - 1;
          }
        }
      });
    });

    document.querySelectorAll('[data-action="increase"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const input = e.target.parentElement.querySelector('input, span');
        const current = parseInt(input.textContent || input.value);
        if (current < 10) {
          if (input.tagName === 'SPAN') {
            input.textContent = current + 1;
          } else {
            input.value = current + 1;
          }
        }
      });
    });

    // Tab navigation
    document.querySelectorAll('.plaud-tabs__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;

        document.querySelectorAll('.plaud-tabs__btn').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.plaud-tabs__content').forEach(c => c.classList.remove('active'));

        btn.classList.add('active');
        document.querySelector(`[data-content="${tab}"]`).classList.add('active');
      });
    });

    // Color selector
    document.querySelectorAll('.plaud-color-card input').forEach(input => {
      input.addEventListener('change', (e) => {
        const colorName = e.target.value;
        document.getElementById('selected-color').textContent = colorName;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
